import * as React from "react";
import {useEffect} from "react";
import {useNavigate , useLocation} from "react-router-dom";
import {DatePicker} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {MarqueOrDivisionFilter} from "./MarqueOrDivisionFilter";
import {Node, Ouvrage} from "../types";
import {useSelector} from "react-redux";
import {State} from "../reducer";
import {getMarqueEditorial, getDivisions} from "../action/marqueEditorialAction";
import {getMevDates} from "../action/ouvrageAction";
import {readQueryParams, searchParam} from "../epic/searchEpic";
import {RunFilter} from "./RunFilter";
import {EtatFilter} from "./EtatFilter";
import {CycladeFilter} from "./CycladeFilter";
import {Button} from '@mui/material';
import { useAppDispatch } from "../store";
import { useUpdateQueryParam } from "../hook";
import { fr } from 'date-fns/locale/fr';


interface Props {
    ouvrages: Ouvrage[]
}

export const AdvancedSearch: React.FC<Props> = (props) => {

    const mevDates = useSelector(({ouvrages}: State) => ouvrages.mevDates);
    const dispatch = useAppDispatch();


    useEffect(() => {
        dispatch(getMevDates());
    }, [dispatch]);

    const divisionList = useSelector(({marqueEditorial}: State) => marqueEditorial.divisions).map(x => {
        return {
            value: x,
            label: x,
            className: '',
        } as Node
    });

    const marqueList = useSelector(({marqueEditorial}: State) => marqueEditorial.marqueEditorial).map(x => {
        return {
            value: x.id,
            label: x.label,
            className: '',
            adGroup: x.groupe
        } as Node
    });

    const collectionsLoading = useSelector(({marqueEditorial}: State) => marqueEditorial.collectionsLoading);

    const navigate = useNavigate();

    useEffect(() => {
            dispatch(getDivisions());
            dispatch(getMarqueEditorial());
        }, [dispatch]
    )


    const searchLocation = useLocation().search;
    const queryFilters = readQueryParams(searchParam, searchLocation);
    const startMev = queryFilters.startDate || mevDates.mevStartDate;
    const endMev = queryFilters.endDate || mevDates.mevEndDate;
    const handleUpdateQueryParam = useUpdateQueryParam();

    function isValidDate(d: any) {
        return d instanceof Date && !isNaN(d.getTime());
    }

    const handleStartMevChange = (date: Date | null) => {
        if (date != null && isValidDate(date)) {
            handleUpdateQueryParam(`startDate`, date.toISOString().split('T')[0])
        }
    };

    const handleEndMevChange = (date: Date | null) => {
        if (date !== null) {
            handleUpdateQueryParam(`endDate`, date.toISOString().split('T')[0])
        }
    };

    return (
        <div className="advanced-search">

            <div>
                <Button variant="outlined" color="primary" size={"small"} onClick={() => {
                    navigate('/');
                }}
                        sx={{marginLeft: "50px"}}>
                    Réinitialiser
                </Button>
            </div>

            <div className="search-date">
                <LocalizationProvider  dateAdapter={AdapterDateFns} adapterLocale={fr}>
                    <div className="date-picker">
                        <DatePicker
                            sx={{paddingBottom: "1rem"}}
                            format="dd/MM/yyyy"
                            label="MEV de début"
                            value={new Date(startMev)}
                            onChange={handleStartMevChange}
                            slotProps={{ textField: { variant: 'standard', } }}
                        />
                    </div>
                    <div className="date-picker">
                        <DatePicker
                            sx={{paddingBottom: "1rem"}}
                            format="dd/MM/yyyy"
                            label="MEV de fin"
                            value={new Date(endMev)}
                            onChange={handleEndMevChange}
                            slotProps={{ textField: { variant: 'standard', } }}
                        />
                    </div>
                </LocalizationProvider>
            </div>
            
            <MarqueOrDivisionFilter label="Marque éditoriale" field="marqueEditoriale" list={marqueList} collectionsLoading={collectionsLoading}/>
            <MarqueOrDivisionFilter label="Division" field="division" list={divisionList} collectionsLoading={collectionsLoading}/>

            <RunFilter/>
            <EtatFilter/>
            <CycladeFilter type={'cyclade'}/>
            <CycladeFilter type={'elib'}/>
        </div>
    )
};
